/**
 * Exit Intent Detection
 * Triggers newsletter popup when user shows exit intent
 */

(function() {
  'use strict';

  let exitIntentTriggered = false;
  const popup = document.querySelector('[data-exit-intent="true"]');

  if (!popup) return;

  // Check if popup was already shown
  const cookieName = 'newsletter_exit_intent_shown';
  const cookieTime = popup.dataset.cookieTime || '7';

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  // Don't show if already displayed
  if (getCookie(cookieName)) {
    return;
  }

  function handleMouseLeave(e) {
    // Detect mouse leaving from top of viewport
    if (e.clientY < 10 && !exitIntentTriggered) {
      exitIntentTriggered = true;

      // Trigger popup
      const toggleButton = document.querySelector('[data-js-toggle="NewsletterPopupToggle"]');
      if (toggleButton) {
        toggleButton.click();
      }

      // Set cookie
      setCookie(cookieName, 'true', parseInt(cookieTime));

      // Remove listener after triggering
      document.removeEventListener('mouseleave', handleMouseLeave);
    }
  }

  // Add exit intent detection after a delay (to avoid immediate trigger)
  setTimeout(() => {
    document.addEventListener('mouseleave', handleMouseLeave);
  }, 5000); // Wait 5 seconds before activating

  // Mobile: Detect when user starts scrolling up (alternative exit intent)
  let lastScrollY = window.scrollY;
  let scrollUpCount = 0;

  function handleScroll() {
    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY) {
      scrollUpCount++;

      // If user scrolled up 3 times and is near top, show popup
      if (scrollUpCount >= 3 && currentScrollY < 500 && !exitIntentTriggered) {
        exitIntentTriggered = true;

        const toggleButton = document.querySelector('[data-js-toggle="NewsletterPopupToggle"]');
        if (toggleButton) {
          toggleButton.click();
        }

        setCookie(cookieName, 'true', parseInt(cookieTime));
        window.removeEventListener('scroll', handleScroll);
      }
    } else {
      scrollUpCount = 0;
    }

    lastScrollY = currentScrollY;
  }

  // Activate scroll detection on mobile
  if (window.innerWidth <= 768) {
    setTimeout(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });
    }, 5000);
  }
})();
